import { useEffect, useRef } from 'react'

type IWidgetKeyboardOptions = {
  onNavigate?: (direction: -1 | 1) => void
  onEnter?: () => void | Promise<void>
  onNext?: () => void
  onSubmit?: () => void
  onEscape: () => void
  isLastStep?: boolean
}

export const useWidgetKeyboard = ({
  onNavigate,
  onEnter,
  onNext,
  onSubmit,
  onEscape,
  isLastStep,
}: IWidgetKeyboardOptions): void => {
  const onNavigateRef = useRef(onNavigate)
  const onEnterRef = useRef(onEnter)
  const onNextRef = useRef(onNext)
  const onSubmitRef = useRef(onSubmit)
  const onEscapeRef = useRef(onEscape)
  const isLastStepRef = useRef(isLastStep)

  onNavigateRef.current = onNavigate
  onEnterRef.current = onEnter
  onNextRef.current = onNext
  onSubmitRef.current = onSubmit
  onEscapeRef.current = onEscape
  isLastStepRef.current = isLastStep

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      switch (e.key) {
        case 'ArrowUp':
          e.preventDefault()
          onNavigateRef.current?.(-1)
          break
        case 'ArrowDown':
          e.preventDefault()
          onNavigateRef.current?.(1)
          break
        case 'Enter':
          const target = e.target as HTMLElement
          const isEditable = target.tagName === 'TEXTAREA' || target.isContentEditable

          if (isEditable && !e.metaKey && !e.ctrlKey) break

          e.preventDefault()
          if (isLastStepRef.current) {
            if (e.metaKey || e.ctrlKey) {
              onSubmitRef.current?.()
            }
          } else if (e.metaKey || e.ctrlKey) {
            onNextRef.current?.()
          } else {
            onEnterRef.current?.()
          }
          break
        case 'Escape':
          onEscapeRef.current()
          break
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [])
}
